module.exports = __webpack_public_path__ + "img/block-right-large.8d1e332b.png";